module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kc-La.5c24ea6e.png";